/**
 * The sent message, straight into the transcript — no round trip in between.
 *
 *   owner, 2026-08-08: 在 project 輸入之後顯示在對話欄裡面的 Latency 非常的高.
 *
 * /project/send already answers with the COMPLETE stored row (message_id, cursor,
 * ts, from_ref) — everything the transcript needs was in hand the moment the send
 * resolved, and the panel was waiting for a reconcile pass to tell it what it had
 * been holding all along. The composer lives in App and the transcript's state
 * lives in useProjectMessages; this is the thinnest bridge between them, and the
 * hook's own de-duplicating merge makes the echo safe — when the same row later
 * arrives by history or (soon) by the push lane, it is recognised, not repeated.
 */
type Listener = (msg: unknown) => void

const subs = new Map<string, Set<Listener>>()

export function onProjectEcho(projectId: string, fn: Listener): () => void {
  const set = subs.get(projectId) ?? new Set()
  set.add(fn)
  subs.set(projectId, set)
  return () => {
    set.delete(fn)
    if (set.size === 0) subs.delete(projectId)
  }
}

export function projectEcho(projectId: string, msg: unknown): void {
  for (const fn of subs.get(projectId) ?? []) fn(msg)
}
